// Анонс без приветствий в начале («Приветствуем вас, дорогие подписчики!») — зеркало backend/text_utils.py.
// Без lookbehind в регулярках: старые Safari на iPhone не умеют и ломают весь бандл.
const GREETING = /^\W*(приветству|здравствуйте|добр(ый|ое|ого)\s+(день|вечер|утр)|всем\s+привет|дорог(ие|ой|ая)\s|уважаем(ые|ый|ая)\s|друзья|коллеги[,!. ]|рады\s+приветствовать|с\s+вами\s)/i;

export function skipGreeting(plain, minRest = 40) {
  const text = plain || "";
  const parts = text.match(/[^.!?…]+[.!?…]+\s*|[^.!?…]+$/g) || [];
  let i = 0;
  while (i < Math.min(2, parts.length) && parts[i].length < 140 && GREETING.test(parts[i])) i += 1;
  const rest = parts.slice(i).join("").trim();
  return i && rest.length >= minRest ? rest : text;
}
